import React from "react";
import { CardContent } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { CardPageItem } from "../../custom/Page";
import AbtcMaterialTable, { newColumn, newColumnBRZ, newColumnCLPD, newColumnText, newColumnUSDt, newColumnValue } from "./TableList";

const hasAnyFilterValue = (filters = {}) =>
  Boolean(
    filters.withdrawId ||
      filters.maxAmount ||
      filters.nameOrEmail ||
      filters.userId ||
      filters.partnerWithdraw ||
      filters.taxResidence ||
      filters.status ||
      filters.dateFilter,
  );

export const buildTotalColumn = (filterTaxResidence, canCalculateTotal = false) => {
  if (!canCalculateTotal) return newColumn("app.total", "invalidTotal", "text", "right");
  if (filterTaxResidence === "") return newColumnValue("app.total", "valueTotalUSDT");
  if (filterTaxResidence === "Colômbia" || filterTaxResidence === "EUA") return newColumnUSDt("app.total", "valueTotalUSDT");
  if (filterTaxResidence === "Chile") return newColumnCLPD("app.total", "valueTotalUSDT");
  if (filterTaxResidence === "Brasil") return newColumnBRZ("app.total", "valueTotalUSDT");
  return newColumnValue("app.total", "valueTotalUSDT");
};

const SummaryCard = ({ data, totalColumn, tableOptions, currentUser, double = false }) => (
  <CardPageItem double={double}>
    <CardContent>
      <AbtcMaterialTable
        data={data}
        columns={[newColumnText("app.description", "label"), newColumn("app.amount", "count", "numeric", "center"), totalColumn]}
        options={{
          ...tableOptions,
          sorting: false,
          padding: "dense",
          rowStyle: { whiteSpace: "nowrap" },
        }}
        user={currentUser}
      />
    </CardContent>
  </CardPageItem>
);

export const buildSummaryItem = (label, count, totalAmount = 0) => ({
  label,
  invalidTotal: <FormattedMessage id="app.withdraw.invalidTotal" />,
  count,
  valueTotalUSDT: totalAmount,
});

export const PendingSummaryCards = ({ rows, totalCount, filterTaxResidence, tableOptions, currentUser, summary, filters }) => {
  const hasMultipleTaxResidences = summary?.hasMultipleTaxResidences ?? summary?.hasMultipleTaxResidence ?? false;
  const canCalculateTotal = hasAnyFilterValue(filters) && !hasMultipleTaxResidences;
  const totalColumn = buildTotalColumn(filterTaxResidence, canCalculateTotal);
  const pendingCount = summary?.totalCount ?? 0;
  const delayedCount = summary?.delayedCount ?? 0;
  const totalAmount = summary?.totalAmount ?? 0;
  const delayedAmount = summary?.delayedAmount ?? 0;

  const listedItem = buildSummaryItem(<FormattedMessage id="app.withdrawals.listed" />, pendingCount, totalAmount);
  const delayedItem = buildSummaryItem(<FormattedMessage id="app.delayed" />, delayedCount, delayedAmount);

  return (
    <>
      <SummaryCard
        data={[listedItem]}
        totalColumn={totalColumn}
        tableOptions={tableOptions}
        currentUser={currentUser}
        double
      />
      <SummaryCard
        data={[delayedItem]}
        totalColumn={totalColumn}
        tableOptions={tableOptions}
        currentUser={currentUser}
        double
      />
    </>
  );
};

export const HistorySummaryCards = ({ rows, totalCount, filterTaxResidence, tableOptions, currentUser, summary, filters }) => {
  const hasMultipleTaxResidences = summary?.hasMultipleTaxResidences ?? summary?.hasMultipleTaxResidence ?? false;
  const canCalculateTotal = hasAnyFilterValue(filters) && !hasMultipleTaxResidences;
  const historyCount = summary?.totalCount ?? 0;
  const historyTotalAmount = summary?.totalAmount ?? 0;

  return (
    <SummaryCard
      data={[buildSummaryItem("Saques listados", historyCount, historyTotalAmount)]}
      totalColumn={buildTotalColumn(filterTaxResidence, canCalculateTotal)}
      tableOptions={tableOptions}
      currentUser={currentUser}
    />
  );
};

export const RedemptionSummaryCards = ({ rows, totalCount, tableOptions, currentUser, summary }) => {
  const hasMultipleTaxResidences = summary?.hasMultipleTaxResidences ?? summary?.hasMultipleTaxResidence ?? false;
  const totalColumn = hasMultipleTaxResidences ? newColumn("app.total", "invalidTotal", "text", "right") : newColumnValue("app.total", "valueTotalUSDT");
  const item = buildSummaryItem("Resgates listados", summary?.totalCount ?? 0, summary?.totalAmount ?? 0);

  return (
    <SummaryCard
      data={[item]}
      totalColumn={totalColumn}
      tableOptions={tableOptions}
      currentUser={currentUser}
    />
  );
};
